import { getRequest, patchRequest } from 'services/requests';

const services = {
    getUser: (id) => getRequest(`/users/${id}`),
    updateUser: (id, body) => patchRequest(`/users/${id}`, body),

    getUserCustomer: (id) => getRequest(`/users/${id}/customers`),
    getUserEntitlements: (id, customerId) => getRequest(`/users/${id}/customers/${customerId}/entitlements`),
    getUserPaymentIntents: (id, customerId) => getRequest(`/users/${id}/customers/${customerId}/payment-intents`),
    getUserPaymentMethod: (id, customerId) => getRequest(`/users/${id}/customers/${customerId}/payment-methods`),
    getUserSubscriptionSchedule: (id, customerId, subscriptionScheduleId) => {
        return getRequest(`/users/${id}/customers/${customerId}/subscription-schedules/${subscriptionScheduleId}`);
    },
    getUserSubscriptions: (id, customerId) => getRequest(`/users/${id}/customers/${customerId}/subscriptions`),
};

export default services;
